export const ESTAGIO_PROSPECCAO = 1;
export const ESTAGIO_CHAMADA_TELEFONICA = 2;
export const ESTAGIO_PRIMEIRA_VISITA = 3;
export const ESTAGIO_EFETIVADO = 4;
export const ESTAGIO_NEGATIVADO = 5;
export const ESTAGIO_SEGUNDA_VISITA = 6;
export const ESTAGIO_EM_ESPERA = 7;
export const ESTAGIO_PERDIDO = 8;
export const ESTAGIO_NEGOCIACAO = 9;



// WEBPACK FOOTER //
// ./src/constants/pedidoEstagio.js